import { isString, trim } from 'lodash';

/**
 * If `val` is a string and is not blank, return `val` as string. Otherwise, return `defaultValue`.
 */
export const toNonBlankString = <TDefault>(val: any, defaultValue: TDefault): string | TDefault =>
  isString(val) && trim(val) ? val : defaultValue;
